import React, { useRef, useState } from "react";

import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Alert,
  TextField,
  Button,
} from "@mui/material";

import axiosClient from "../axiosClient";
import axiosClientSevan from "../axiosClientSevan";
import { useNavigate } from "react-router-dom";

export default function RegisterScreen() {
  const emailRef = useRef();
  const [message, setMessage] = useState();
  const [successMessage, setSuccessMessage] = useState();
  const [disableRegister, setDisableRegister] = useState(false);
  const [disableGoBack, setDisableGoBack] = useState(false);
  const navigate = useNavigate();

  const handleRegister = () => {
    const payload = {
      params: {
        email: emailRef.current.value,
      },
    };

    if (payload.params.email.length === 0) {
      setMessage("Write your email and then proceed with register");
      setTimeout(() => setMessage(null), 3000);
    } else {
      setDisableGoBack(true)
      setDisableRegister(true)
      axiosClient
        .post("auth/register", payload)
        .then((response) => {
          const payloadSevan = {
            first_name: emailRef.current.value,
            email: emailRef.current.value,
            password: response.data.otp,
            platform_name: "SOFTECH",
          };

          setSuccessMessage(response.data.message);

          axiosClientSevan
            .post("api/create/customer", payloadSevan)
            .then((response) => {
              const payload_bill = {
                params: {
                  email: emailRef.current.value,
                  cust_bill_id: parseInt(response.data.data.customer_code),
                },
              };
              axiosClient
                .patch("auth/customer/bill", payload_bill)
                .then(() => {
                  console.log("customer bill id updated")
                  setTimeout(() => {
                    navigate("/login")
                    setDisableGoBack(false)
                    setDisableRegister(false)
                  }, 3000);
                })
                .catch((err) => console.log(err));
            }).catch((err) => {
              //edw o customer iparxei sto sistima tou sevan alla oxi sto diko mas sistima
              const payload_bill = {
                params: {
                  email: emailRef.current.value,
                  cust_bill_id: parseInt(err.response.data.data.customer_code),
                },
              };
              axiosClient
                .patch("auth/customer/bill", payload_bill)
                .then(() => {
                  console.log("customer bill id updated")
                  setTimeout(() => {
                    navigate("/login")
                    setDisableGoBack(false)
                    setDisableRegister(false)
                  }, 3000);
                })
                .catch((err) => console.log(err));
            });
        })
        .catch((err) => {
          setDisableGoBack(false)
          setDisableRegister(false)
          const response = err.response;
          if (response && response.status === 401) {
            setMessage(response.data.message);
            setTimeout(() => {
              setMessage(null);
              emailRef.current.value = null;
            }, 3000);
          } else {
            console.log(err);
          }
        });
    }
  };

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ minHeight: "100vh" }}
    >
      <Grid item xs={12} sm={8} md={6}>
        <Card style={{ maxWidth: 400 }}>
          <CardContent>
            <Typography variant="h5" component="h2" align="center" gutterBottom>
              Register
            </Typography>
            <Box sx={{ "& .MuiTextField-root": { width: "100%" } }}>
              <form>
                {message && (
                  <Alert severity="error" sx={{ marginBottom: 2 }}>
                    {message}
                  </Alert>
                )}
                {successMessage && (
                  <Alert severity="success" sx={{ marginBottom: 2 }}>
                    {successMessage}
                  </Alert>
                )}
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      label="Email"
                      variant="outlined"
                      fullWidth
                      inputRef={emailRef}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      disabled={disableRegister}
                      variant="contained"
                      color="primary"
                      fullWidth
                      onClick={handleRegister}
                    >
                      Register
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      disabled={disableGoBack}
                      variant="contained"
                      color="error"
                      fullWidth
                      onClick={() => navigate("/login")}
                    >
                      Go back
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </Box>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
